import React, { useState } from 'react';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import TestimonialsVideoPopup from './TestimonialsVideoPopup';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import { IconButton } from '@mui/material';

export default function TestimonialsVideoComponent(props) {
  const { isSmallScreen, imageUrl, videoUrl } = props;
  const [openModal, setOpenModal] = useState(false);

  const handleOpen = () => {
    setOpenModal(true);
  };

  return (
    <div onClick={(e) => handleOpen(e)}>
      <Card sx={{ maxWidth: 445, margin: "auto", cursor: "pointer", width: isSmallScreen ? "90%" : "100%" }}>
        <CardMedia
          sx={{ height: 240, opacity: "80%" }}
          image={imageUrl}
          title="Testimonial"
        />
        <IconButton style={{position: 'absolute', transform: 'translate(350%, -270%)', color: "white", fontSize: "40px"}}>
          <PlayCircleIcon fontSize="inherit" onClick={(e) => handleOpen(e)}/>
        </IconButton>
      </Card>
      {openModal &&
        <TestimonialsVideoPopup openModal={openModal} setOpenModal={setOpenModal} isSmallScreen={isSmallScreen} videoUrl={videoUrl}/>
      }
    </div>
  );
}